module.exports = __webpack_public_path__ + "img/DSC_1828.c652e78a.jpeg";